import React from 'react'

function EmbroideryErrorInBatchHeader() {
    return (
        <thead className='thead-light SewingRepairInBatchHeader'>
            <tr>
                <th className='Barcode'>Barcode</th>
                <th className='ProductType'>SKU</th>
                <th className='Status'>Trạng thái</th>
                <th className='BatchName'>Tên lô</th>
                <th className='Size'>Size</th>
                <th className='CreatedDate'>Ngày báo lỗi</th>
                <th className='ErrorType'>Loại lỗi</th>
                <th className='Partner'>Đối tác</th>
            </tr>
        </thead>
    )
}

export default EmbroideryErrorInBatchHeader